import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ListFilter from './filters/ListFilter';
import PaginationButtons from './PaginationButtons';
import NoResults from './ui/NoResults';
import ListHeader from './ui/ListHeader';

import config from './../config';
import helpers from './../lib/helpers';

function SongList(props) {
	const [data, setData] = useState(null);
	const [nextUrl, setNextUrl] = useState(null);
	const [previousUrl, setPreviousUrl] = useState(null);
	const [resultCount, setResultCount] = useState(0);
	const [loading, setLoading] = useState(true);

	const history = useHistory();

	useEffect(() => {
		if (!data) {
			fetchData();
		}
	});

	useEffect(() => {
		fetchData();
	}, [props.locationId, props.searchParams]);

	const fetchData = () => {
		setLoading(true);

		let urlParams = [];

		if (props.book) {
			urlParams.push('book='+props.book);
		}

		if (props.person) {
			urlParams.push('person='+props.person);
		}

		if (props.searchParams) {
			let params = helpers.parseSearchParams(props.searchParams);

			if (params.nafn) {
				urlParams.push('headline='+params.nafn)
			}

			if (params.bok) {
				urlParams.push('book='+params.bok)
			}

			if (params.notur) {
				urlParams.push('has_notes=true')
			}

			if (params.laglina) {
				urlParams.push('melody='+helpers.normalizeNotes(helpers.stringToNotes(params.laglina)).join(' '))
			}

			if (params.sida) {
				urlParams.push('limit='+config.pageSize);
				urlParams.push('offset='+(config.pageSize*(params.sida-1)))
			}
		}

		helpers.fetch(config.apiRoot+'/api/song/?'+urlParams.join('&'), (json) => {
			if (json) {
				setData(json.results);
				setNextUrl(json.next);
				setPreviousUrl(json.previous);
				setResultCount(json.count);

				if (props.onResponse) {
					props.onResponse(json.results);
				}
			}
			setLoading(false);
		});
	}

	return (
		<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
			<LoadingBar />
			{
				props.enableFilter &&
				<ListFilter advanced={false} advancedButtonLabel={'Leit eftir laglínum'} filters={[
					{
						label: 'Heiti',
						paramName: 'nafn',
						type: 'text'
					},
					{
						label: 'Stafrænar nótur tiltækar',
						paramName: 'notur',
						type: 'select',
						selectOptions: {
							options: [
								{
									label: 'Já',
									value: 'ja'
								}
							]
						}
					},
					{
						label: window.l('Handrit/bók'),
						paramName: 'bok',
						type: 'multiselect',
						selectOptions: {
							endpoint: 'book',
							labelField: 'number',
							valueField: 'id',
							filterParam: 'name_startswith'
						},
						viewAllLink: helpers.routerUrls['baekur']
					},
					{
						label: window.l('Leit eftir laglínum'),
						type: 'heading',
						includeInAdvanced: false
					},
					{
						label: 'Hér er hægt að slá inn hluta af laglínu og fá niðurstöður úr þeim lögum þar sem stafrænar nótur eru fyrir hendi',
						paramName: 'laglina',
						type: 'musicsheet',
						fullWidth: true,
						includeInAdvanced: false
					}
				]}
				currentParams={props.searchParams}
				onFilter={(event) => {
					history.push(history.location.pathname+helpers.updateSearchParams(props.searchParams, event));
				}} />
			}
			{
				data && data.length > 0 &&
				<React.Fragment>
					{
						props.children
					}

					<ListHeader resultCount={resultCount} />

					<table className="table">
						<thead>
							<tr>
								<th>Heiti</th>
								<th>Stafrænar nótur</th>
							</tr>
						</thead>
						<tbody>
							{
								data.map((item, index) => <tr key={index}>
									<td>
										<Link to={helpers.routerUrls['log']+item.id}>
											{
												item.headline
											}
										</Link>
									</td>
									<td>{item.musicxml_url ? 'Stafrænar nótur tiltækar' : ''}</td>
								</tr>)
							}
						</tbody>
					</table>
					{
						resultCount > config.pageSize &&
						<PaginationButtons resultCount={resultCount}
							previousUrl={previousUrl}
							nextUrl={nextUrl} />
					}
				</React.Fragment>
			}
			{
				data && data.length == 0 && !loading &&
				<NoResults />
			}
		</div>
	)
}

export default SongList;
